import { DEFAULT_FORMATTER_LOCALE } from '../../constants/defaultFormatterLocale'
import { getFormatLocale } from '../getFormatLocale'
import { getNumberSeparators } from './getNumberSeparators'
import { liberalParseToNumber } from './utils/liberalParseToNumber'
import { strictParseToNumber } from './utils/strictParseToNumber'

export const parseToNumber = (input = '', inputLocale?: string, isStrict = false): number => {
  const locale = getFormatLocale(inputLocale || DEFAULT_FORMATTER_LOCALE)

  if (isStrict) {
    return strictParseToNumber(input, getNumberSeparators(locale))
  }

  return liberalParseToNumber(input, inputLocale ? getNumberSeparators(locale) : undefined)
}
